const MyBonnieLiesOverTheOcean = [
	'[Verse 1]',
	'My Bonnie is over the ocean,',
	'my Bonnie is over the sea,',
	'my Bonnie is over the ocean,',
	'bring back my Bonnie to me.',
	'',
	'[Chorus]',
	'Bring back, bring back,',
	'bring back, my Bonnie to me, to me,',
	'Bring back, bring back,',
	'bring back my Bonnie to me.',
	'',
	'[Verse 2]',
	'blow ye winds over the ocean,',
	'blow ye winds over the sea,',
	'blow ye winds over the ocean,',
	'and bring back my Bonnie to me.',
	'',
	'[Chorus]',
	'Bring back, bring back,',
	'bring back, my Bonnie to me, to me,',
	'Bring back, bring back,',
	'bring back my Bonnie to me.',
	'',
	'[Verse 3]',
	'Last night as I lay on my pillow,',
	'last night as I lay on my bed,',
	'last night as I lay on my pillow,',
	'I dreamed that my Bonnie was dead.',
	'',
	'[Chorus]',
	'Bring back, bring back,',
	'bring back, my Bonnie to me, to me,',
	'Bring back, bring back,',
	'bring back my Bonnie to me.',
	'',
	'[Verse 4]',
	'The winds have blown over the ocean,',
	'the winds have blown ov- er the sea,',
	'the winds have blown over the ocean,',
	'and brought back my Bonnie to me.',
	'',
	'[Chorus]',
	'Brought back, brought back,',
	'brought back, my Bonnie to me, to me,',
	'Brought back, brought back,',
	'brought back my Bonnie to me.',
];

export default MyBonnieLiesOverTheOcean;
